var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLayer2Left(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 331,
    height: 230,
    viewBox: "0 0 331 230",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 331,
    height: 230,
    fill: "url(#paint0_linear_3063_15057)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3063_15057",
    x1: 331,
    y1: 115,
    x2: 0,
    y2: 115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4EEFD",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.466346,
    stopColor: "#F4EEFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4EEFD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayer2Left);
export default __webpack_public_path__ + "static/media/layer2-left.81fe73320edac89bc5ab8f1d5097e21b.svg";
export { ForwardRef as ReactComponent };